import React, { Component } from "react";
import MyPATStep, { MyPATStepSubHeading, MyPATStepTitle } from "./MyPATStep";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Theme, Typography } from "@material-ui/core";
import { StepProps } from "./types/Stepper";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { StepStatus } from "../common/types/Stepper";
import  ProgressBar from "../content-request/containers/CardData/CardDataTabs/ProgressBar";
const styles = (theme: Theme) =>
  createStyles({
    lable: {
      fontSize: "16px",
      color: "#333",
      fontWeight: 500,
    },
    value: {
      fontSize: "14px",
      color: "#666",
      fontWeight: "normal",
    },
    statusIconContainer: {
      marginRight: "14px",
    },
    progressStyle: {
      "&>div:nth-of-type(1)": {
        display: "flex",
        alignItems: "center",
        '&>div:nth-of-type(1)':{
          minWidth: '85px',
          margin: '0 5px',
        },
      },
    },
    linearProgressStyle:{
      minWidth: '85px',
      margin: '0 5px',
    },
    contentDescription:{
      border: "1px solid #DFDFDF",
      borderRadius:4,
      marginBottom: 12,
      padding: '16px 12px',
    },
    iconStatus:{
      padding: '2px 4px 2px 4px',
      '& img':{
        verticalAlign: 'bottom'
      }
    }
  });
interface Props extends WithStyles<typeof styles>,StepProps {
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
  title: React.ReactNode;
  subHeading?: React.ReactNode;
  secondarySummary?: React.ReactNode;
  descriptionHeading?: React.ReactNode;
  description?:React.ReactNode;
  taskStatus?:React.ReactNode;
  progress?:string;
  percent?:number;
  genericSecondarySummary?:React.ReactNode;
  count?: number;
  totalCount?: number;
}
interface State {
  expanded: boolean;
}
const width = '150px';
const marginLeft = '900px'
class MyPATExpansionStepSubCard extends Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = {
        expanded: props.expanded || false,
      };
    }
    componentDidUpdate(prevProps: Props) {
      if (prevProps.expanded !== this.props.expanded) {
        this.setState({
          expanded: !!this.props.expanded,
        });
      }
    }
    handleChange = (_event: any, expanded: boolean) => {
      if (this.props.onChange) {
        this.props.onChange(expanded);
      } else {
        this.setState({
          expanded,
        });
      }
    };
    renderStatusIcon = () => {
        const { status } = this.props;
        let path = "";
        switch (status) {
          case StepStatus.PENDING: {
            path = "/assets/svg/contentRequest/step-pending.svg";
            break;
          }
          case StepStatus.INPROGRESS: {
            path = "/assets/svg/contentRequest/step-inprogress.svg";
            break;
          }
          case StepStatus.DONE: {
            path = "/assets/svg/contentRequest/step-done.svg";
            break;
          }
          default: 
            break;
        }
        return <img src={path} alt={status} />;
      };
    render() {
        const {
            status,
            title,
            subHeading,
            children,
            secondarySummary,
            descriptionHeading,
            description,
            classes,
            taskStatus,
            progress,
            percent,
            genericSecondarySummary,
            count,
            totalCount
        } = this.props;
        console.log(percent);
      const { expanded } = this.state;
      return (
            <Grid container justify="flex-start" alignItems="center" className={classes.contentDescription}>
              <Grid item xs={!genericSecondarySummary ? (progress ? 3 : 4) : 6}>
                <MyPATStep plain>
                  <Grid container>
                    <Grid item xs={12}>
                      <MyPATStepTitle>
                        <Grid container justify="flex-start" alignItems="center">
                          <Grid item className={classes.iconStatus}>
                            {this.renderStatusIcon()}
                          </Grid>
                          <Grid item>
                            {title}
                          </Grid>                          
                        </Grid>
                        </MyPATStepTitle>
                    </Grid>
                  </Grid>
                </MyPATStep>
              </Grid>
              {secondarySummary && (
                <Grid item xs={progress ? 3 : 4}>
                  <Grid container justify={progress ? "flex-start" : "flex-start"} alignItems="center">
                    <Grid item>
                    {secondarySummary}
                    </Grid>
                  </Grid>
                </Grid>
              )}

          {genericSecondarySummary && (
            <Grid item xs={6}>
              {genericSecondarySummary}
            </Grid>
              )}
  
             {taskStatus && (
                <>
                {progress &&
                    <Grid item xs={3}>
                        {progress}
                    </Grid>
                }
                    <Grid item xs={progress ? 3 : 4} className={classes.progressStyle}>
                    {/* <span className={classes.linearProgressStyle}> */}
                        {!progress ?
                        <Grid container justify="flex-end" alignItems="center">
                        <Grid item>
                        <ProgressBar percentage={percent} count={count} totalCount={totalCount} />
                          </Grid>  
                        </Grid> 
                        :
                        <ProgressBar percentage={percent} count={count} totalCount={totalCount} />
                    }
                    {/* </span> */}
                    </Grid>
                 </>
              )}
            </Grid>
      );
    }
  }
  // @ts-ignore
  export default withStyles(styles)(MyPATExpansionStepSubCard)